import { spaces, widths } from './space.token';
import { cpdsMediaQueryVals, mediaQueries } from './common.token';
// import * as hotelsToken from './hotels.token';
// import * as vrboToken from './vrbo.token';

export { spaces, widths, cpdsMediaQueryVals, mediaQueries };
import * as colorToken from './colour.token';
import * as spacingToken from './spacing.token';
import * as mediaQueriesToken from './common.token';
import * as fontFamily from './fontfamilies.token';

const color = colorToken.cpds_brand_colors;
const spacing = spacingToken.spacings;
const fontFamilies = fontFamily.fontFamily;
const fontSize = fontFamily.fontSize;
const fontLineHeight = fontFamily.fontLineHeight;
const unitlessFontSize = fontFamily.unitlessFontSize;
const unitlessFontLineHeight = fontFamily.unitlessFontLineHeight;
const fontWeight = fontFamily.fontWeight;
const mediaQueryVals = mediaQueriesToken.cpdsMediaQueryVals;

export { color, spacing, mediaQueryVals, fontFamilies, fontSize, unitlessFontSize, fontLineHeight, unitlessFontLineHeight, fontWeight };
